module.exports = __webpack_public_path__ + "static/media/fed.099dacdc.png";